import * as React from 'react';

import { ExternalLinkIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  icon?: boolean;
  external?: boolean;
  children?: React.ReactNode;
}

const Link = ({
  external = false,
  icon = false,
  children,
  className,
  ref,
  ...rest
}: LinkProps & { ref?: React.Ref<HTMLAnchorElement> }) => {
  const externalProps = external ? { target: '_blank' as const, rel: 'noopener noreferrer' } : {};

  return (
    <a
      {...externalProps}
      {...rest}
      ref={ref}
      className={cn('cursor-pointer text-primary underline', className)}
    >
      {children}
      {icon && (
        <i className="mx-1 inline-flex align-bottom">
          <ExternalLinkIcon size={16} className="text-muted-foreground" />
        </i>
      )}
    </a>
  );
};

export default Link;
